import React from 'react'
import Svg, { G, Path, Defs, ClipPath, SvgProps } from 'react-native-svg'

const TickIcon = (props: SvgProps) => {
  return (
    <Svg width={12} height={12} fill="none" {...props}>
      <G clipPath="url(#a)">
        <Path
          stroke="#0E7A41"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.25}
          d="m10.125 3.375-5.25 5.25L2.25 6"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h12v12H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default TickIcon
